module.exports = __webpack_public_path__ + "img/nrs_pay_ad.c02de4c7.gif";